export default __webpack_public_path__ + "static/media/Image.db025e3e.png";